import React, { Component } from 'react';
import TagManager from 'react-gtm-module';
import { steps } from '../helpers/Lists.js';
import { LenderRow } from '../components/LenderRow.tsx';
import { HomeSvg } from '../svg/HomeSvg.tsx';

interface IProps {
    gtmTag: string;
    showCalculators: boolean;
    nextStep(s: string): void;
}

export class BuyOrSwitch extends Component<IProps, any> {

    componentDidMount(): void {
        if (this.props.gtmTag !== '') {
            const tagManagerArgs = {
                gtmId: this.props.gtmTag
            };
            TagManager.initialize(tagManagerArgs);
        }
    }

    render() {

        return (
            <header className="App-header">
                <h1>Let's get started. Are you looking to buy or switch?</h1>
                <p>Are you a new home buyer, or a homeowner looking to switch to something more suitable?</p>
                <div className='wrapper'>
                    <div className='row mt-2'>
                        <div className='column2 justify-e'>
                            <div className='boxty big' onClick={() => this.props.nextStep(steps.purchaser)}>
                                <div>
                                    <div><HomeSvg/></div>
                                    <div><span className='b'>Buy a home</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='boxty big' onClick={() => this.props.nextStep(steps.switcher)}>
                                <div>
                                    <div><i className="std fa fa-calculator s30" /></div>
                                    <div><span className='b'>Switch my mortgage</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                    {this.props.showCalculators &&
                    <>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <div className='row'>
                            <div className='column2'>
                                <div className='boxty big' onClick={() => this.props.nextStep(steps.purchasing_calculator)}>
                                    <div>
                                        <div className='reduce'></div>
                                        <div><span className='b'>Purchaser Calculator</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className='column2'>
                                <div className='boxty big' onClick={() => this.props.nextStep(steps.switching_calculator)}>
                                    <div>
                                        <div className='reduce'></div>
                                        <div><span className='b'>Switcher Calculator</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='column2'>
                                <div className='boxty big' onClick={() => this.props.nextStep(steps.overpayment_calculator)}>
                                    <div>
                                        <div className='reduce'></div>
                                        <div><span className='b'>Overpayment Calculator</span></div>
                                    </div>
                                </div>
                            </div>
                            <div className='column2'>
                                <div className='boxty big' onClick={() => this.props.nextStep(steps.insurance_for)}>
                                    <div>
                                        <div className='reduce'></div>
                                        <div><span className='b'>Insurance Quote</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    }
                </div>
            </header>
        );
    }
}
